import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import { createTrainingPeriod, formatPeriodLabel } from "../../api/trainingCohorts";
import "./TrainingPeriodModal.css";

type Props = {
  onClose: () => void;
  onCreated: () => void;
};

export function TrainingPeriodModal({ onClose, onCreated }: Props) {
  const now = new Date();
  const [year, setYear] = useState(String(now.getFullYear()));
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    const y = Number(year);
    const m = Number(month);
    if (!Number.isInteger(y) || !Number.isInteger(m) || m < 1 || m > 12) {
      setError("Gecerli bir yil ve ay girin.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await createTrainingPeriod({ year: y, month: m });
      onCreated();
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Donem olusturulamadi.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="kp-modal-backdrop" role="dialog" aria-modal="true">
      <div className="kp-modal kp-card kp-training-period">
        <div className="kp-modal__head">
          <div>
            <strong>Yeni Kayit Donemi</strong>
            <span>Varsayilan 3 grup x 3 alt grup olusturulur</span>
          </div>
          <button type="button" className="kp-btn kp-btn--ghost" onClick={onClose} disabled={submitting}>
            Kapat
          </button>
        </div>
        <form className="kp-training-period__form" onSubmit={submit}>
          <label className="kp-training-period__field">
            <span>Yil</span>
            <input
              className="kp-input"
              type="number"
              min={2000}
              max={2100}
              required
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
          </label>
          <label className="kp-training-period__field">
            <span>Ay (1-12)</span>
            <input
              className="kp-input"
              type="number"
              min={1}
              max={12}
              required
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
          </label>
          <p className="kp-training-period__hint">
            Ornek etiket: {formatPeriodLabel(Number(year) || 2026, Number(month) || 1)} · Grup 1 ·
            A ŞUBESİ
          </p>
          {error && <div className="kp-training-period__error">{error}</div>}
          <div className="kp-training-period__actions">
            <button type="button" className="kp-btn" onClick={onClose} disabled={submitting}>
              Iptal
            </button>
            <button type="submit" className="kp-btn kp-btn--primary" disabled={submitting}>
              {submitting ? "Olusturuluyor…" : "Donemi Ac"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
